module.exports = __webpack_public_path__ + "img/antes_despues_04.bb16639d.png";